/** Base scene object */
import { getContext } from 'kontra';

export default class BaseScene {
  constructor () {
    this.context = getContext();
  }

  onEnter () {}

  onExit () {}

  update () {}

  render () {}

  log (msg) {
    console.log(`[${this.constructor.name}: ${msg}]`);
  }
}
